window.onload = function (event) {

    console.log('Buscador 1 ');
    // Search Image Crest
    const searchImageCrest = {
        debug: true,
        documentCrestForm: document.formCrestFamily,
        url: document.getElementById('formCrestFamily').getAttribute("data-url"),
        errorTitle: document.getElementById('formCrestFamily').getAttribute("data-error-title"),
        errorTitle: document.getElementById('formCrestFamily').getAttribute("data-error-title"),
        
        init: function () {
            if (this.debug) { console.log('init'); };
            if (this.debug) { console.log('form:',this.documentCrestForm); };
            if (this.debug) { console.log('url:',this.url); };
            document.getElementsByClassName('search-result')[0].innerHTML = '<svg xmlns="http://www.w3.org/2000/svg" width="48" height="48" viewBox="0 0 24 24"><use href="#svg-spinners" /></svg>';
            document.getElementsByClassName('search-result')[0].classList.remove("svg_hidden");
            if (this.validate(document.getElementById("term").value)) {
                this.send();
            }
        },
        validate: function (field) {
            if (this.debug) { console.log('Vlidate:', field); };
            error = '';
            // Form data to be validated
            error += this.valid_complete(field, "* Name");
            
            if (this.debug) { console.log(error); };

            if (error != '') {
                title = 'Empty Data';
                this.showImage(error);
                return false
            }
            return true;
        },
        valid_complete: function (obj, name, type) {
            if (this.debug) { console.log('valid Compelete'); };
            if (type == 'int') { 
                if ((obj.value=='')||(isNaN(obj.value))){ 
                    return "\n <strong>"+name+"</strong> requires only numbers.<br>"; 
                }else{ 
                    return ""; 
                }
            }else if(obj.value=='' ){ 
                return "\n <strong>"+name+"</strong> is required.<br>"; 
            }else{ 
                return ""; 
            }
        },
        valid_length: function (obj, name, leng) {
            if (this.debug) { console.log('valid Length'); };
            if (obj.length >= leng) { 
                    return ""; 
            } else {
                return "\n <strong>"+name+"</strong> requires at least 2 letters.<br>"; ; 
            }
        },
        showMsn: function (title, errors) {
            if (this.debug) { console.log('Show Erro Message'); };
            document.getElementsByClassName('message')[0].classList.add("show");
            document.getElementsByClassName('message-title')[0].innerHTML = title;
            document.getElementsByClassName('message-main')[0].innerHTML = errors;
        },
        showImage: function (response) {
            if (this.debug) { console.log('Show Erro Message'); };
            if(response[0] != undefined && response[0] != ''){
                image = response[0][0][1][0]['crest_url'];
                document.getElementsByClassName('search-result')[0].classList.add("show");
                document.getElementsByClassName('search-result')[0].innerHTML = `<div class="cont-img"><img src="https://hjlibrary.gohapp.com/files/crests/${image}" alt="Image"></div>`;
                // Add dato to post
                document.getElementById("file_crest").value = `https://hjlibrary.gohapp.com/files/crests/${image}`;
            } else {
                // document.getElementsByClassName('search-result')[0].classList.add("show");
                document.getElementsByClassName('search-result')[0].innerHTML = '<div class="cont-img">No se encotraron resultados</div>';
            }
            
        },
        send: function () {

            if (this.debug) { console.log('!!!!!!!!!!! Send Form:'); };

            formdata = new FormData();
            formdata.append('term', document.getElementById("term").value);
            formdata.append('dataset[info]', '');
            formdata.append('dataset[crest]', 'crest');
            formdata.append('dataset[image]', '');

            fetch(`${this.url}`, {
                method: 'POST',
                body: formdata
            })
            .then(response => response.json())
                .then(response => {
                // Susses Menssage
                if (this.debug) { console.log(JSON.stringify(response)); };
                this.showImage(response);
            })
            .catch(err => {
                // Error Menssage
                if (this.debug) { console.log(JSON.stringify(err)); };
                this.showImage('');
            })
        },
    };

    document.getElementsByClassName("search-button")[0].addEventListener("click", function (event) {
        searchImageCrest.init();
        console.log('boton');
    });

    // Search Image Crest
    const secondSearchImageCrest = {
        debug: true,
        documentCrestFormSecond: document.formCrestFamily2,
        url: document.getElementById('formCrestFamily2').getAttribute("data-url"),
        errorTitle: document.getElementById('formCrestFamily2').getAttribute("data-error-title"),
        errorTitle: document.getElementById('formCrestFamily2').getAttribute("data-error-title"),
        
        init: function () {
            if (this.debug) { console.log('init'); };
            if (this.debug) { console.log('form:',this.documentCrestFormSecond); };
            if (this.debug) { console.log('url:',this.url); };
            document.getElementsByClassName('search-result2')[0].innerHTML = '<svg xmlns="http://www.w3.org/2000/svg" width="48" height="48" viewBox="0 0 24 24"><use href="#svg-spinners" /></svg>';
            document.getElementsByClassName('search-result2')[0].classList.remove("svg_hidden");
            if (this.validate(document.getElementById("term-two").value)) {
                this.send();
            }
        },
        validate: function (field) {
            if (this.debug) { console.log('Vlidate:', field); };
            error = '';
            // Form data to be validated
            error += this.valid_complete(field, "* Name");
            
            if (this.debug) { console.log(error); };

            if (error != '') {
                title = 'Empty Data';
                this.showImage(error);
                return false
            }
            return true;
        },
        valid_complete: function (obj, name, type) {
            if (this.debug) { console.log('valid Compelete'); };
            if (type == 'int') { 
                if ((obj.value=='')||(isNaN(obj.value))){ 
                    return "\n <strong>"+name+"</strong> requires only numbers.<br>"; 
                }else{ 
                    return ""; 
                }
            }else if(obj.value=='' ){ 
                return "\n <strong>"+name+"</strong> is required.<br>"; 
            }else{ 
                return ""; 
            }
        },
        valid_length: function (obj, name, leng) {
            if (this.debug) { console.log('valid Length'); };
            if (obj.length >= leng) { 
                    return ""; 
            } else {
                return "\n <strong>"+name+"</strong> requires at least 2 letters.<br>"; ; 
            }
        },
        showMsn: function (title, errors) {
            if (this.debug) { console.log('Show Erro Message'); };
            document.getElementsByClassName('message')[0].classList.add("show");
            document.getElementsByClassName('message-title')[0].innerHTML = title;
            document.getElementsByClassName('message-main')[0].innerHTML = errors;
        },
        showImage: function (response) {
            if (this.debug) { console.log('Show Erro Message 2'); };
            if(response[0] != undefined && response[0] != ''){
                image = response[0][0][1][0]['crest_url'];
                document.getElementsByClassName('search-result2')[0].classList.add("show");
                document.getElementsByClassName('search-result2')[0].innerHTML = `<div class="cont-img"><img src="https://hjlibrary.gohapp.com/files/crests/${image}" alt="Image"></div>`;
                // Add dato to post
                document.getElementById("file_crest_two").value = `https://hjlibrary.gohapp.com/files/crests/${image}`;
            } else {
                // document.getElementsByClassName('search-result2')[0].classList.add("show");
                document.getElementsByClassName('search-result2')[0].innerHTML = '<div class="cont-img">No se encotraron resultados</div>';
            }
            
        },
        send: function () {

            if (this.debug) { console.log('!!!!!!!!!!! Send Form 2:'); };

            formdata = new FormData();
            formdata.append('term', document.getElementById("term-two").value);
            formdata.append('dataset[info]', '');
            formdata.append('dataset[crest]', 'crest');
            formdata.append('dataset[image]', '');

            fetch(`${this.url}`, {
                method: 'POST',
                body: formdata
            })
            .then(response => response.json())
                .then(response => {
                // Susses Menssage
                if (this.debug) { console.log(JSON.stringify(response)); };
                this.showImage(response);
            })
            .catch(err => {
                // Error Menssage
                if (this.debug) { console.log(JSON.stringify(err)); };
                this.showImage('');
            })
        },
    };

    document.getElementsByClassName("search-button-two")[0].addEventListener("click", function (event) {
        secondSearchImageCrest.init();
        console.log('boton');
    });
}